/**"yandex-metrika-module-nuxt3": "^1.5.3" */
/* eslint-disable */
// @ts-nocheck
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public;
  let loadedMetrica = false,
    timerId;
  if (process.client) {
    (function () {
      function loadMetrica(e) {
        if (e && e.type) {
          console.log(e.type);
        } else {
          console.log('DOMContentLoaded');
        }
        if (loadedMetrica) {
          return;
        }
        (function (m, e, t, r, i, k, a) {
          m[i] =
            m[i] ||
            function () {
              (m[i].a = m[i].a || []).push(arguments);
            };
          m[i].l = 1 * new Date();
          (k = e.createElement(t)),
            (a = e.getElementsByTagName(t)[0]),
            (k.async = 1),
            (k.src = r),
            a.parentNode.insertBefore(k, a);
        })(
          window,
          document,
          'script',
          'https://mc.yandex.ru/metrika/tag.js',
          'ym',
        );
        ym(config.yandexMetrikaId, 'init', {
          clickmap: true,
          webvisor: true,
          trackLinks: true,
          accurateTrackBounce: true,
        });
        loadedMetrica = true;
        clearTimeout(timerId);
        window.removeEventListener('scroll', loadMetrica);
        window.removeEventListener('touchstart', loadMetrica);
        document.removeEventListener('mouseenter', loadMetrica);
        document.removeEventListener('click', loadMetrica);
        document.removeEventListener('DOMContentLoaded', loadFallback);
      }

      function loadFallback() {
        timerId = setTimeout(loadMetrica, 1000);
      }

      if (navigator.userAgent.indexOf('YandexMetrika') > -1) {
        loadMetrica();
      } else {
        window.addEventListener('scroll', loadMetrica, { passive: true });
        window.addEventListener('touchstart', loadMetrica);
        document.addEventListener('mouseenter', loadMetrica);
        document.addEventListener('click', loadMetrica);
        document.addEventListener('DOMContentLoaded', loadFallback);
      }
    })();
  }
});
